import React, { memo } from 'react'
import { format } from 'date-fns'
import isSameYear from 'date-fns/isSameYear'
import { de, fr } from 'date-fns/locale'
import i18n from 'atpjs/helpers/i18n'
import { DAY_PATTERN, LARGE_DATE_PATTERN } from 'tve/helpers/date'

const dateLocale = {
  de,
  fr
}

const computeLargeDisplay = (start, end) => {
  const pattern = LARGE_DATE_PATTERN[i18n.locale]
  const locale = dateLocale[i18n.locale]
  return `${format(start, pattern, { locale })} - ${format(end, pattern, { locale })}`
}

const computeSmallDisplay = (start, end) => {
  const startMonth = start.getMonth()
  const endMonth = end.getMonth()
  if (startMonth === endMonth) {
    return `${format(start, DAY_PATTERN[i18n.locale])} - ${format(end, DAY_PATTERN[i18n.locale])} ${format(
      start,
      'MMM',
      {
        locale: dateLocale[i18n.locale]
      }
    )}`
  } else {
    return `${format(start, DAY_PATTERN[i18n.locale])} ${format(start, 'MMM', {
      locale: dateLocale[i18n.locale]
    })} - ${format(end, DAY_PATTERN[i18n.locale])} ${format(end, 'MMM', {
      locale: dateLocale[i18n.locale]
    })}`
  }
}

const WeekDisplay = memo((props) => {
  const { startCell, endCell } = props
  return (
    <div className="atp-time-week__current">
      {isSameYear(startCell.start, endCell.end)
        ? computeSmallDisplay(startCell.start, endCell.start)
        : computeLargeDisplay(startCell.start, endCell.start)}
    </div>
  )
})

WeekDisplay.displayName = 'WeekDisplay'

export default WeekDisplay
